import { Col, message } from "antd";
import { Icons } from "../assets/icons";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import SatageSubHeader from "../components/ui/SatageSubHeader";
import SectionTwo from "../components/PolicyAndCommitmentSections/SectionTwo";
import ViewReportCard from "../components/ui/ViewReportCard";

const footerText = (
  <p>
    Involving employees in decision-making processes can enhance their
    motivation and commitment to creating psychologically healthy and safe
    workplaces. Encouraging and supporting voluntary participation is more
    effective and sustainable than mandating it. Concerns about engaging workers
    may include fears of pushback, negative attitudes, apathy, and the sensitive
    nature of psychosocial hazards. These concerns often stem from past
    unsuccessful initiatives. Therefore, it is essential to address the concerns
    of workers and other stakeholders when applying the wellbeing guidance
    program and to promote participation and consultation. Engaging worker
    representatives, where available, can help alleviate these concerns
  </p>
);

const stepsList = (
  <>
    <li>a. Review your case</li>
    <li>b. Establish a wellbeing committee</li>
    <li>c. Conduct an organizational review</li>
    <li>d. Formulate a policy statement </li>
    <li>e. Communicate the policy statement</li>
  </>
);

const overviewText = (
  <p>
    Welcome to the Policy & Commitment Stage, where you will establish, review,
    or enhance your organization’s well-being policies and secure leadership
    commitment. Begin by reviewing existing policies or creating new ones using
    the platform’s customizable templates. You can upload current policies, edit
    them to align with your organizational needs, or build new ones from scratch
    using the policy editor. Once finalized, assign these policies to specific
    departments, teams, or the entire organization and notify employees to
    review and digitally acknowledge them.
  </p>
);

function CompanyAwarenessPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      {/* Header */}
      <PageHeader
        stage={2}
        title={"POLICY & COMMITMENT"}
        icon={
          <Icons.PolicyCommitmentStageIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
          />
        }
      />
      {/* Sub Header  */}
      <SatageSubHeader overviewText={overviewText} stepsList={stepsList} />

      {/* View Report */}
      <ViewReportCard
        title="your case"
        text="Review your resulted report from awareness stage 1"
        btnName="view report"
        btnAction={() => message.info("This report is not yet available.")}
      />

      {/* Steps Section */}
      <SectionTwo />

      {/* Footer */}
      <FooterQuoteCard
        icon={<Icons.PolicyCommitmentIcon width={350} height={350} />}
        text={footerText}
      />
    </Col>
  );
}

export default CompanyAwarenessPage;
